import { DrawerLayout } from '@/components/layouts/DrawerLayout.jsx';
import { IngredientForm } from '../components/IngredientForm';
import { useParams } from "react-router-dom";   
import { useGetIngredientQuery, useUpdateIngredientMutation } from '../api';

export function UpdateIngredientPage() {
  const { id } = useParams();
  const { isFetching, data } = useGetIngredientQuery({ id });

  const [saveIngredient, saveResult] = useUpdateIngredientMutation();

  function save(data) {
    return saveIngredient({ id, data });
  }

  return (    
    <DrawerLayout title="Update Ingredient">      
      {isFetching ? 'Loading...' : <IngredientForm data={data.data} save={save} saveResult={saveResult} />}
    </DrawerLayout>
  );
}

